import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { Icon, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, IconButton, Skeleton, TextField } from '@mui/material';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import { exportCSVFromDataGrid } from 'src/utils/exportCSV';
import { getMonetaryValue } from 'src/utils/typeFormaters';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { UnitCell } from './UnitCell';
import { MoveOutCell } from './MoveOutCell';
import { ResidentCell } from './ResidentCell';
import { OccupancyCell } from './OccupancyCell';
import { BillingOptOutCell } from './BillingOptOutCell';
import { BalanceCell } from './BalanceCell';
import { ActionsCell } from './ActionsCell';
import { ResidenciesCheckElement } from './residenciesCheckElement';
import RippleEffect from 'src/components/general/RippleEffect';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import ResidentModal from 'src/components/resident/ResidentModal';
import FSEBillModal from 'src/components/resident/ResidentModal/MoveOutTab/FSEBillModal';
import OccupancyUpdateModal from 'src/components/unit/OccupancyUpdateModal';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import moment from 'moment';
import useStyles from './styles';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import { DateInlineCell } from './DateInlineCell';
// import TableInformationModal from './TableInformationModal';

export const MultiPropertyResidenciesDataGrid = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS6, _store$homeDashboardS0, _store$homeDashboardS11, _store$homeDashboardS15, _modalTempData$rowDat, _modalTempData$rowDat2, _store$homeDashboardS16, _modalTempData$rowDat3;
  let searchKey = _ref.searchKey,
    selectedRows = _ref.selectedRows,
    setSelectedRows = _ref.setSelectedRows,
    residenciesFilterStatus = _ref.residenciesFilterStatus,
    propertyIds = _ref.propertyIds,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Residencies Page';
  const isFinalStatementEstimationEnabled = store.account.featureFlagsStore.isFinalStatementEstimationEnabled;
  const selectedUnit = store.fse.FSEBillModalData;
  const includeEmptyUnits = (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyResidentsTabOptions) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.includeEmptyUnitsFlag;
  const _useState = useState({
      // NOTE: Hide columns propertyAddress and portfolioName when only one property is selected
      unitPropertyAddress: store.homeDashboardStore.selectedPropertyId === 'all',
      unitPortfolioName: store.homeDashboardStore.selectedPropertyId === 'all'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    columnVisibilityModel = _useState2[0],
    setColumnVisibilityModel = _useState2[1];
  const getActivePropertiesByNavSelection = store.homeDashboardStore.getCurrentCompanyPropertiesByNavSelection.filter(property => {
    var _property$dashboard;
    return (property === null || property === void 0 || (_property$dashboard = property.dashboard) === null || _property$dashboard === void 0 ? void 0 : _property$dashboard.propertyStatus) === PROPERTY_STATUS_ENUM.Active;
  });
  const getResidentsBySelectedProperties = () => {
    return getActivePropertiesByNavSelection.map(i => i.residents).flat();
  };
  const getResidentRows = getResidentsBySelectedProperties().filter(r => includeEmptyUnits ? residenciesFilterStatus.includes(r.status) || r.status === null : residenciesFilterStatus.includes(r.status)).filter(i => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(i.fullname).search(searchPhrase) > 0 || " ".concat(i.unitName).search(searchPhrase) > 0 : true;
  });
  const _useState3 = useState('overview'),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTab = _useState4[0],
    setActiveTab = _useState4[1];
  const _useState5 = useState('livable-solution'),
    _useState6 = _slicedToArray(_useState5, 2),
    livableTab = _useState6[0],
    setLivableTab = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    tenantModalIsOpen = _useState8[0],
    setTenantModalIsOpen = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    currentResidentId = _useState0[0],
    setCurrentResidentId = _useState0[1];
  const _useState1 = useState('N/A'),
    _useState10 = _slicedToArray(_useState1, 2),
    currentUnitName = _useState10[0],
    setCurrentUnitName = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    currentAccountId = _useState12[0],
    setCurrentAccountId = _useState12[1];
  const _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    currentPropertyIdForResidentModal = _useState14[0],
    setCurrentPropertyIdForResidentModal = _useState14[1];
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    dataNavigation = _useState16[0],
    setDataNavigation = _useState16[1];
  const _useState17 = useState({
      unitname: null,
      occupancy: null,
      unitData: null,
      rowData: null
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    modalTempData = _useState18[0],
    setMmodalTempData = _useState18[1];
  const unitNameColumnWidth = useMemo(() => {
    if (!getResidentRows.length) return 82;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.font = '14px Inter, sans-serif';
    const maxWidth = Math.max(ctx.measureText('Unit').width, ...getResidentRows.map(r => {
      var _r$unitName;
      return ctx.measureText((_r$unitName = r.unitName) !== null && _r$unitName !== void 0 ? _r$unitName : '').width;
    }));
    return Math.ceil(maxWidth) + 82;
  }, [getResidentRows]);
  const _useState19 = useState({
      pageSize: 50,
      page: 0
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    paginationModel = _useState20[0],
    setPaginationModel = _useState20[1];
  const _useState21 = useState([{
      field: 'unitName',
      sortable: true,
      sort: 'asc'
    }
    // NOTE: disabling undesired sorting fields
    // { field: 'Fullname', sortable: false },
    // { field: 'enrolledDateOnly', sortable: false },
    // { field: 'moveOut', sortable: false },
    // { field: 'occupancy', sortable: false },
    // { field: 'billingOpt', sortable: false },
    // // { field: 'lastStatement', sortable: false },
    // { field: 'averageStatement', sortable: false },
    // { field: 'balance', sortable: false },
    // { field: 'actions', sortable: false },
    ]),
    _useState22 = _slicedToArray(_useState21, 2),
    sortModel = _useState22[0],
    setSortModel = _useState22[1];

  // TODO: fix for what needed
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getFSEInfos = async residencyIds => {
    const resp = await store.fse.getFSEInfosAsync.run({
      residencyIds
    });
    return resp;
  };
  const fetchUtilitiesInfo = async utilityIds => {
    var _store$homeDashboardS2;
    return (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.fetchUtilitiesInfo(utilityIds);
  };
  const collectResidentsUtilityIds = () => {
    const res = getResidentsBySelectedProperties().map(r => r.residencyUtilityIds);
    return Array.from(new Set(res.flat()));
  };
  const submitFinalStatements = async () => {
    const resp = await store.fse.submitFinalStatementsAsync.run({
      residencyId: selectedUnit.residencyId
    });
    return resp;
  };
  const handleSetSortModel = async data => {
    var _data;
    if (!((_data = data) !== null && _data !== void 0 && _data.length)) {
      data = [{
        field: 'unitName',
        sort: 'asc'
      }];
    }
    setSortModel(data);
  };
  const handleSetPaginationModel = async data => {
    setPaginationModel(data);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getResidenciesMultiproperty = async _ref2 => {
    let handleSetSortModelExt = _ref2.handleSetSortModelExt,
      handleSetPaginationModelExt = _ref2.handleSetPaginationModelExt;
    // NOTE: reset data grid filter model to default state
    // if (!(handleSetSortModelExt && handleSetSortModelExt?.length && handleSetSortModelExt[0].field)) {
    //   handleSetSortModel(undefined);
    // }
    const resp = await store.residencies.searchResidenciesAggregateAsync.run({
      portfolioIds: [],
      propertyIds: store.homeDashboardStore.getCurrentCompanyPropertiesByNavSelection.filter(property => {
        var _property$dashboard2;
        return (property === null || property === void 0 || (_property$dashboard2 = property.dashboard) === null || _property$dashboard2 === void 0 ? void 0 : _property$dashboard2.propertyStatus) === PROPERTY_STATUS_ENUM.Active;
      }).map(property => property.id),
      includeEmptyUnits: includeEmptyUnits,
      // searchQuery: searchKey,
      sortBy: handleSetSortModelExt && handleSetSortModelExt !== null && handleSetSortModelExt !== void 0 && handleSetSortModelExt.length && handleSetSortModelExt[0].field ? handleSetSortModelExt[0].field : 'unitName',
      // NOTE: FIX: BIB-227 sortModel[0]?.field,
      sortOrder: handleSetSortModelExt && handleSetSortModelExt !== null && handleSetSortModelExt !== void 0 && handleSetSortModelExt.length && handleSetSortModelExt[0].sort ? handleSetSortModelExt[0].sort : 'asc',
      // NOTE: FIX: BIB-227 sortModel[0]?.sort,
      // page: 0,
      // handleSetPaginationModel && isValueNumber(handleSetPaginationModel?.page)
      //   ? handleSetPaginationModel?.page + 1
      //   : paginationModel.page + 1,
      // pageSize: 500,
      // handleSetPaginationModel && isValueNumber(handleSetPaginationModel?.pageSize)
      //   ? handleSetPaginationModel?.pageSize
      //   : paginationModel.pageSize,
      statuses: residenciesFilterStatus
      // statuses: [
      //   RESIDENCY_STATUS_KEY_VALUES.Current,
      //   RESIDENCY_STATUS_KEY_VALUES.Future,
      //   RESIDENCY_STATUS_KEY_VALUES.FormerActive,
      //   RESIDENCY_STATUS_KEY_VALUES.FormerClosed,
      // ],
    }, [...store.homeDashboardStore.getCurrentCompanyPropertiesIdsByNavSelection]);
    return resp;
  };
  const fetchResidencies = _ref3 => {
    var _store$homeDashboardS3, _store$homeDashboardS4;
    let handleSetSortModelExt = _ref3.handleSetSortModelExt,
      handleSetPaginationModelExt = _ref3.handleSetPaginationModelExt;
    if (!(propertyIds !== null && propertyIds !== void 0 && propertyIds.length)) return;
    Promise.all([getResidenciesMultiproperty({
      handleSetSortModelExt,
      handleSetPaginationModelExt
    }), (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.fetchPropertyInformationBatch(getActivePropertiesByNavSelection.map(property => ({
      propertyId: property.id,
      portfolioId: property.propertyPortfolioInfo.id
    }))), (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.fetchBuildingsInformationBatch(getActivePropertiesByNavSelection.map(property => ({
      propertyId: property.id,
      portfolioId: property.propertyPortfolioInfo.id
    })))]).then(async () => {
      store.residenciesMultiActionStore.deselectAll();
      for (const property of getActivePropertiesByNavSelection) {
        var _store$homeDashboardS5;
        await ((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.propertyDetails(property.id)) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.details.fetchUtilityTemplates({
          useUnicInProgress: true,
          customUnicInProgress: getActivePropertiesByNavSelection.map(p => p.id)
        }));
      }
      await fetchUtilitiesInfo(collectResidentsUtilityIds());
      const fseResidencyIds = getActivePropertiesByNavSelection.flatMap(p => {
        var _p$residents;
        return (_p$residents = p.residents) !== null && _p$residents !== void 0 ? _p$residents : [];
      }).map(r => r.residencyId).filter(Boolean);
      if (isFinalStatementEstimationEnabled && fseResidencyIds.length > 0) {
        try {
          await getFSEInfos(fseResidencyIds);
        } catch (e) {
          console.error('getFSEInfos failed', e);
        }
      }
    }).finally(() => {});
  };
  useEffect(() => {
    fetchResidencies({
      handleSetSortModelExt: undefined,
      handleSetPaginationModelExt: undefined
    });
    setColumnVisibilityModel({
      propertyAddress: store.homeDashboardStore.selectedPropertyId === 'all',
      portfolioName: store.homeDashboardStore.selectedPropertyId === 'all'
    });
  }, [includeEmptyUnits, residenciesFilterStatus, store.homeDashboardStore.getCurrentCompanyPropertiesIdsByNavSelection, (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.companyResidentsTabOptions) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.refreshResidentsFlag]);
  const changeCurrentResidentId = id => {
    setCurrentResidentId(id);
  };
  const changeCurrentUnitName = name => {
    setCurrentUnitName(name);
  };

  // NOTE: and TODO this may cause not needed refreshes
  const closeModal = () => {
    // fetchResidencies({
    //   handleSetSortModelExt: undefined,
    //   handleSetPaginationModelExt: undefined,
    // });
    setTenantModalIsOpen(false);
  };
  const openTenantModal = tab => {
    if (['livable-solution', 'billing-settings', 'occupancy'].includes(tab)) {
      setActiveTab('livable-solution');
      setLivableTab(tab);
    } else {
      setActiveTab(tab);
    }
    setTenantModalIsOpen(true);
  };
  const setNewNavigationParameters = (currAccountId, currResidencyId) => {
    if (getResidentRows.length <= 1) return;
    let filteredUnitsList = getResidentRows.filter(item => item.accountId && item.residencyId);
    if (sortModel) {
      const unitNameSortFunctionAsc = (v1, v2) => {
        var _store$homeDashboardS7;
        if (((_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompanyPropertiesIdsByNavSelection) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.length) === 1) {
          var _ref4;
          return (_ref4 = '' + v1.unitName) === null || _ref4 === void 0 ? void 0 : _ref4.localeCompare(v2.unitName, undefined, {
            numeric: true
          });
        } else {
          var _ref5, _ref6;
          return ((_ref5 = '' + v1.unitName) === null || _ref5 === void 0 ? void 0 : _ref5.localeCompare(v2.unitName, undefined, {
            numeric: true
          })) && ((_ref6 = '' + v1.unitPropertyAddress) === null || _ref6 === void 0 ? void 0 : _ref6.localeCompare(v2.unitPropertyAddress, undefined, {
            numeric: true
          }));
        }
      };
      const unitNameSortFunctionDesc = (a, b) => {
        return -unitNameSortFunctionAsc(a, b);
      };
      if (['unitName'].includes(sortModel[0].field)) {
        if (sortModel[0].sort === 'asc') {
          filteredUnitsList = filteredUnitsList.sort(unitNameSortFunctionAsc);
        } else {
          filteredUnitsList = filteredUnitsList.sort(unitNameSortFunctionDesc);
        }
      }
    }
    const currUnitIndex = filteredUnitsList.findIndex(item => item.accountId === currAccountId && item.residencyId === currResidencyId);
    if (currUnitIndex === -1) return;
    const resultData = [];
    if (filteredUnitsList.length <= 1) {
      setDataNavigation(resultData);
      return;
    }
    if (currUnitIndex === 0) {
      resultData.push({
        next: {
          residencyId: filteredUnitsList[currUnitIndex + 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex + 1].unitName,
          accountId: filteredUnitsList[currUnitIndex + 1].accountId,
          propertyId: filteredUnitsList[currUnitIndex + 1].propertyId
        }
      });
    } else if (currUnitIndex === filteredUnitsList.length - 1) {
      resultData.push({
        prev: {
          residencyId: filteredUnitsList[currUnitIndex - 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex - 1].unitName,
          accountId: filteredUnitsList[currUnitIndex - 1].accountId,
          propertyId: filteredUnitsList[currUnitIndex - 1].propertyId
        }
      });
    } else {
      resultData.push({
        next: {
          residencyId: filteredUnitsList[currUnitIndex + 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex + 1].unitName,
          accountId: filteredUnitsList[currUnitIndex + 1].accountId,
          propertyId: filteredUnitsList[currUnitIndex + 1].propertyId
        },
        prev: {
          residencyId: filteredUnitsList[currUnitIndex - 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex - 1].unitName,
          accountId: filteredUnitsList[currUnitIndex - 1].accountId,
          propertyId: filteredUnitsList[currUnitIndex - 1].propertyId
        }
      });
    }
    setDataNavigation(resultData);
  };
  const handleCellClick = params => {
    var _store$homeDashboardS8;
    setCurrentUnitName(params.row.unitName);
    setCurrentAccountId(params.row.accountId);
    setCurrentResidentId(params.row.residencyId);
    setCurrentPropertyIdForResidentModal(params.row.propertyId);
    setNewNavigationParameters(params.row.accountId, params.row.residencyId);
    if ((_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS8 !== void 0 && _store$homeDashboardS8.companyFeatureSet.isAppfolio && params.field === 'occupancy') return;
    if (params.field === 'select' || params.field === 'actions' || params.field === 'moveOut' || params.field === 'propertyAddress' || params.field === 'portfolioName' || params.field === 'enrolledDateOnly' || params.field === 'billingStartDateOnly' || !params.row.accountId || params.row.isEnrolmentScheduled) return;
    let modalTab = 'overview';
    switch (params.field) {
      case 'moveOut':
        modalTab = 'move-out';
        break;
      case 'occupancy':
        modalTab = 'livable-solution';
        break;
      case 'billingOpt':
        modalTab = 'billing-settings';
        break;
      case 'balance':
        modalTab = 'overview';
        break;
    }
    openTenantModal(modalTab);
  };
  const handleNavigation = data => {
    setCurrentUnitName(data.unitName);
    setCurrentAccountId(data.accountId);
    setCurrentResidentId(data.residencyId);
    setCurrentPropertyIdForResidentModal(data.propertyId);
    setNewNavigationParameters(data.accountId, data.residencyId);
    openTenantModal('overview');
  };
  const handleSubmitFinalStatements = () => submitFinalStatements().then(() => {
    toast('success', {
      body: ['Final statement sent']
    });
  }).finally(() => {
    store.residencies.toggleRefreshFlag(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    parentToggleRefreshCallback && parentToggleRefreshCallback();
  });
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const renderHeaderWithInfo = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlignFlex : ''
  }, text, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    placement: "top",
    title: "Average Statement is system-calculated amount from all historical statements."
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  })))), indicators);

  // const Cell = ({ field, row }) => {
  //   return (
  //     <>
  //       {!row.accountId ? (
  //         <span className={classes.disabledCellText}>N/A</span>
  //       ) : (
  //         <RippleEffect
  //           className={`${row?.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent} cellContent`}
  //         >
  //           {field}
  //         </RippleEffect>
  //       )}
  //     </>
  //   );
  // };

  const CellByType = observer(_ref7 => {
    let field = _ref7.field,
      row = _ref7.row,
      type = _ref7.type;
    if (type === 'unitPropertyAddress' || type === 'unitPortfolioName') {
      var _store$buildings$getB, _store$properties$get;
      if ((_store$buildings$getB = store.buildings.getBuildingsBatchAsync) !== null && _store$buildings$getB !== void 0 && (_store$buildings$getB = _store$buildings$getB.inProgressUnicIds) !== null && _store$buildings$getB !== void 0 && _store$buildings$getB.includes(row === null || row === void 0 ? void 0 : row.propertyId) || (_store$properties$get = store.properties.getPropertiesBatchAsync) !== null && _store$properties$get !== void 0 && (_store$properties$get = _store$properties$get.inProgressUnicIds) !== null && _store$properties$get !== void 0 && _store$properties$get.includes(row === null || row === void 0 ? void 0 : row.propertyId)) {
        return /*#__PURE__*/React.createElement(Skeleton, {
          variant: "text",
          animation: "wave",
          width: 200,
          height: 24
        });
      }
      return /*#__PURE__*/React.createElement(ExpandedTooltip, {
        hideOnMobile: true,
        placement: "top",
        title: row[type]
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.tooltipContent
      }, /*#__PURE__*/React.createElement(RippleEffect, {
        className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
      }, row[type])));
      // } else if (type === 'unitPortfolioName') {
      //   // if (false) {
      //   //   // note: tbd may be needed
      //   //   return <Skeleton variant="text" animation="wave" width={82} height={24} />;
      //   // }
      //   return (
      //     <RippleEffect
      //       className={`${row?.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent} cellContent`}
      //     >
      //       <BasicTooltip title={row[type]} placement="top" hideOnMobile>
      //         {row[type]}
      //       </BasicTooltip>
      //     </RippleEffect>
      //   );
    } else if (type === 'enrolledDateOnly') {
      return !row.accountId ? /*#__PURE__*/React.createElement("span", {
        className: classes.disabledCellText
      }, "N/A") : /*#__PURE__*/React.createElement(RippleEffect, {
        className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
      }, dateToFormat(row.enrolledDateOnly));
    } else if (type === 'averageStatement') {
      return !row.accountId ? /*#__PURE__*/React.createElement("span", {
        className: classes.disabledCellText
      }, "N/A") : /*#__PURE__*/React.createElement(RippleEffect, {
        className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
      }, getMonetaryValue(row.averageStatement));
    } else {
      return !row.accountId ? /*#__PURE__*/React.createElement("span", {
        className: classes.disabledCellText
      }, "N/A") : /*#__PURE__*/React.createElement(ExpandedTooltip, {
        hideOnMobile: true,
        placement: "top",
        title: field
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.tooltipContent
      }, /*#__PURE__*/React.createElement(RippleEffect, {
        className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
      }, field)));
    }
  });
  let columns = [{
    field: 'select',
    headerName: t('Row checkbox'),
    align: 'center',
    width: 74,
    sortable: false,
    hideable: false,
    renderCell: params => {
      return /*#__PURE__*/React.createElement(ResidenciesCheckElement, {
        disabled: !params.row.accountId,
        data: _objectSpread(_objectSpread({}, params.row), {}, {
          id: params.row.residencyId,
          accountId: params.row.accountId,
          unitName: params.row.unitName,
          name: params.row.fullname,
          occupancy: params.row.occupancy,
          isEmail: !!params.row.email || !!params.row.newEmail
        })
      });
    },
    renderHeader: () => /*#__PURE__*/React.createElement(ResidenciesCheckElement, {
      rows: getResidentRows
    })
  }, {
    isExportable: true,
    field: 'unitName',
    headerName: t('general.unit'),
    hideable: false,
    align: 'right',
    width: unitNameColumnWidth,
    valueGetter: params => {
      var _params$row$unitName, _params$row$unitPrope;
      return {
        name: (_params$row$unitName = params.row.unitName) !== null && _params$row$unitName !== void 0 ? _params$row$unitName : '',
        address: (_params$row$unitPrope = params.row.unitPropertyAddress) !== null && _params$row$unitPrope !== void 0 ? _params$row$unitPrope : ''
      };
    },
    valueGetterForExport: params => params.row.unitName,
    renderCell: params => /*#__PURE__*/React.createElement(UnitCell, {
      params: params
    }),
    renderHeader: () => renderHeader(t('general.unit')),
    sortComparator: (v1, v2) => {
      var _store$homeDashboardS9;
      const compare = (a, b) => a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
      const isSingleCompany = ((_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompanyPropertiesIdsByNavSelection) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.length) === 1;
      if (isSingleCompany) return compare(v1.name, v2.name);
      return compare(v1.address, v2.address) || compare(v1.name, v2.name);
    }
  }, {
    isExportable: true,
    align: 'left',
    field: 'fullname',
    headerName: t('Full Name'),
    minWidth: (_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS0 !== void 0 && _store$homeDashboardS0.companyFeatureSet.isAppfolio ? 300 : 390,
    hideable: false,
    valueGetter: params => params.row.fullname,
    renderCell: params => /*#__PURE__*/React.createElement(ResidentCell, {
      handleClick: handleCellClick,
      params: params
      // parentToggleRefreshCallback={parentToggleRefreshCallback}
      ,
      setMmodalTempData: setMmodalTempData
    }),
    renderHeader: () => {
      var _store$homeDashboardS1, _store$homeDashboardS10;
      return renderHeader(t('residencies_page.residencies_cell', {
        residenciesCount: store.residencies.searchResidenciesAggregateAsync.inProgress ? '∞' : (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.companyResidentsTabOptions) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.residenciesCount,
        unitsCount: store.residencies.searchResidenciesAggregateAsync.inProgress ? '∞' : (_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.companyResidentsTabOptions) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.unitsCount
      }));
    },
    flex: 0.75
  }, {
    isExportable: true,
    field: 'unitPropertyAddress',
    headerName: t('general.property_address'),
    align: 'left',
    minWidth: 200,
    valueGetter: params => params.row.unitPropertyAddress,
    renderCell: params => /*#__PURE__*/React.createElement(CellByType, {
      field: params.row.unitPropertyAddress,
      row: params.row,
      type: 'unitPropertyAddress'
    }),
    renderHeader: () => renderHeader(t('general.property_address')),
    sortComparator: (v1, v2) => {
      var _ref8;
      return (_ref8 = '' + v1) === null || _ref8 === void 0 ? void 0 : _ref8.localeCompare(v2, undefined, {
        numeric: true
      });
    },
    flex: 0.6
  }, {
    isExportable: true,
    field: 'unitPortfolioName',
    headerName: t('portfolios_properties_page.portfolio_name'),
    align: 'left',
    minWidth: 180,
    valueGetter: params => params.row.unitPortfolioName,
    renderCell: params => /*#__PURE__*/React.createElement(CellByType, {
      field: params.row.unitPortfolioName,
      row: params.row,
      type: 'unitPortfolioName'
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.portfolio_name')),
    sortComparator: (v1, v2) => {
      var _ref9;
      return (_ref9 = '' + v1) === null || _ref9 === void 0 ? void 0 : _ref9.localeCompare(v2, undefined, {
        numeric: true
      });
    },
    flex: 0.45
  }, {
    isExportable: true,
    field: 'enrolledDateOnly',
    width: 125,
    headerName: (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS11 !== void 0 && _store$homeDashboardS11.companyFeatureSet.isAppfolio ? t('residencies_page.move-in_date_cell') : t('residencies_page.enrolled_date_cell'),
    headerAlign: 'left',
    align: 'left',
    sortable: true,
    valueGetter: params => {
      var _params$row$enrolledD;
      return (_params$row$enrolledD = params.row.enrolledDateOnly) !== null && _params$row$enrolledD !== void 0 && _params$row$enrolledD.length ? moment(params.row.enrolledDateOnly).format('MM/DD/YYYY') : null;
    },
    renderCell: params => {
      var _store$homeDashboardS12;
      if ((_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS12 !== void 0 && _store$homeDashboardS12.companyFeatureSet.isAppfolio) {
        return /*#__PURE__*/React.createElement(CellByType, {
          field: params.row.enrolledDateOnly,
          row: params.row,
          type: 'enrolledDateOnly'
        });
      } else {
        if (!params.row.accountId) {
          return /*#__PURE__*/React.createElement("span", {
            className: classes.disabledCellText
          }, "N/A");
        } else {
          return /*#__PURE__*/React.createElement(DateInlineCell, {
            field: params.row.enrolledDateOnly,
            row: params.row,
            fieldId: "enrolledDateOnly"
          });
        }
      }
    },
    renderHeader: () => {
      var _store$homeDashboardS13;
      return renderHeader((_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS13 !== void 0 && _store$homeDashboardS13.companyFeatureSet.isAppfolio ? t('residencies_page.move-in_date_cell') : t('residencies_page.enrolled_date_cell'), true);
    },
    sortComparator: (v1, v2) => {
      const v1Date = moment(v1);
      const v2Date = moment(v2);
      if (v1Date.isValid() && v2Date.isValid()) {
        return v1Date.diff(v2Date);
      } else {
        var _ref0;
        return (_ref0 = '' + v1) === null || _ref0 === void 0 ? void 0 : _ref0.localeCompare(v2, undefined, {
          numeric: true
        });
      }
    }
  }, {
    isExportable: true,
    field: 'moveOut',
    headerName: t('residencies_page.move-out_date_cell'),
    width: 132,
    headerAlign: 'left',
    align: 'left',
    sortable: true,
    valueGetter: params => params.row.moveOutDateOnly,
    renderCell: params => /*#__PURE__*/React.createElement(MoveOutCell, {
      params: params,
      openTenantModal: openTenantModal,
      changeCurrentResidentId: changeCurrentResidentId,
      changeCurrentUnitName: changeCurrentUnitName
    }),
    renderHeader: () => renderHeader(t('residencies_page.move-out_date_cell'), true),
    sortComparator: (v1, v2) => {
      const v1Date = moment(v1);
      const v2Date = moment(v2);
      if (v1Date.isValid() && v2Date.isValid()) {
        return v1Date.diff(v2Date);
      } else {
        var _ref1;
        return (_ref1 = '' + v1) === null || _ref1 === void 0 ? void 0 : _ref1.localeCompare(v2, undefined, {
          numeric: true
        });
      }
    }
  }, {
    isExportable: true,
    field: 'occupancy',
    headerName: t('residencies_page.occupancy_cell'),
    width: 77,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    valueGetter: params => params.row.occupancy,
    renderCell: params => /*#__PURE__*/React.createElement(OccupancyCell, {
      params: params,
      setMmodalTempData: setMmodalTempData
    }),
    renderHeader: () => renderHeader(t('residencies_page.occupancy_cell'), true)
  }, {
    field: 'billingOpt',
    headerName: t('residencies_page.utility_enrolment'),
    isExportable: true,
    width: 107,
    headerAlign: 'right',
    align: 'right',
    sortable: true,
    valueGetter: params => {
      var _store$homeDashboardS14;
      // Return plain text value for export
      const getBillingOptIds = (arr1, arr2) => {
        const unique1 = arr1.map(u => u.utilityId).filter(u => arr2.indexOf(u.utilityId) === -1);
        const unique2 = arr2.filter(u => arr1.indexOf(u) === -1);
        return unique1.concat(unique2);
      };
      const billingOptOutIds = getBillingOptIds(params.row.residencyUtilityOptOuts, params.row.unitUtilityOptOuts.map(i => i.utilityId) || []);
      const total = (_store$homeDashboardS14 = store.homeDashboardStore.getCurrentCompany.propertyDetails(params.row.propertyId)) === null || _store$homeDashboardS14 === void 0 || (_store$homeDashboardS14 = _store$homeDashboardS14.details[store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? 'billingTemplatesList' : 'utilityTemplatesList']) === null || _store$homeDashboardS14 === void 0 ? void 0 : _store$homeDashboardS14.length;
      const active = total - (billingOptOutIds === null || billingOptOutIds === void 0 ? void 0 : billingOptOutIds.length);
      return "".concat(active, " out of ").concat(total);
    },
    renderCell: params => /*#__PURE__*/React.createElement(BillingOptOutCell, {
      params: params
    }),
    renderHeader: () => renderHeader(t('residencies_page.utility_enrolment'), true)
  },
  // {
  //   field: 'lastStatement',
  //   width: 102,
  //   headerAlign: 'right',
  //   align: 'right',
  //   sortable: false,
  //   renderCell: params => <Cell field={params.row.lastStatement} row={params.row} />,
  //   renderHeader: () => renderHeader(t('residencies_page.last_statement_cell'), true),
  // },
  {
    align: 'right',
    field: 'averageStatement',
    isExportable: true,
    headerName: t('residencies_page.average_statement_cell'),
    headerAlign: 'right',
    sortable: false,
    valueGetter: params => getMonetaryValue(params.row.averageStatement),
    valueGetterForExport: params => params.row.averageStatement,
    renderCell: params => /*#__PURE__*/React.createElement(CellByType, {
      field: params.row.averageStatement,
      row: params.row,
      type: 'averageStatement'
    }),
    renderHeader: () => renderHeaderWithInfo(t('residencies_page.average_statement_cell'), true),
    width: 150
  }, {
    field: 'balance',
    headerName: t('residencies_page.current_balance_cell'),
    width: 112,
    headerAlign: 'right',
    isExportable: true,
    align: 'right',
    sortable: false,
    valueGetter: params => getMonetaryValue(params.row.currentBalance),
    valueGetterForExport: params => params.row.currentBalance,
    renderCell: params => /*#__PURE__*/React.createElement(BalanceCell, {
      params: params
    }),
    renderHeader: () => renderHeader(t('residencies_page.current_balance_cell'), true)
  }, {
    field: 'actions',
    headerName: t('Actions'),
    width: 72,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    filterable: false,
    hideable: false,
    renderCell: params => {
      var _params$row, _params$row2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !(!!params.row.accountId && !((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled)) && !store.company.companyFeatureStore.disableAccountOverview && /*#__PURE__*/React.createElement(ActionsCell, {
        params: params,
        setMmodalTempData: setMmodalTempData,
        openTenantModal: openTenantModal,
        changeCurrentResidentId: changeCurrentResidentId,
        changeCurrentUnitName: changeCurrentUnitName
      }), !!params.row.accountId && !((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.isEnrolmentScheduled) && /*#__PURE__*/React.createElement(ActionsCell, {
        params: params,
        setMmodalTempData: setMmodalTempData,
        openTenantModal: openTenantModal,
        changeCurrentResidentId: changeCurrentResidentId,
        changeCurrentUnitName: changeCurrentUnitName
      }));
    },
    renderHeader: () => /*#__PURE__*/React.createElement("div", {
      className: classes.toolboxWrapperHeader
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      type: "button",
      'custom-attribute': '220-ResidenciesDataGrid'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    })))
  }];
  if ((_store$homeDashboardS15 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS15 !== void 0 && _store$homeDashboardS15.companyFeatureSet.isAppfolio) {
    const fullnameIndex = columns.findIndex(i => i.field === 'enrolledDateOnly');
    if (fullnameIndex !== -1) {
      columns.splice(fullnameIndex + 1, 0, ...[{
        field: 'billingStartDateOnly',
        headerName: t('Billing Start Date'),
        width: 125,
        headerAlign: 'left',
        align: 'left',
        sortable: true,
        isExportable: true,
        valueGetter: params => {
          var _params$row$billingSt;
          return (_params$row$billingSt = params.row.billingStartDateOnly) !== null && _params$row$billingSt !== void 0 && _params$row$billingSt.length ? moment(params.row.billingStartDateOnly).format('MM/DD/YYYY') : null;
        },
        renderCell: params => {
          if (!params.row.accountId) {
            return /*#__PURE__*/React.createElement("span", {
              className: classes.disabledCellText
            }, "N/A");
          } else {
            return /*#__PURE__*/React.createElement(DateInlineCell, {
              field: params.row.billingStartDateOnly,
              row: params.row,
              fieldId: "billingStartDateOnly"
            });
          }
        },
        renderHeader: () => renderHeader(t('residencies_page.billing_start_date_cell'), true),
        sortComparator: (v1, v2) => {
          const v1Date = moment(v1);
          const v2Date = moment(v2);
          if (v1Date.isValid() && v2Date.isValid()) {
            return v1Date.diff(v2Date);
          } else {
            var _ref10;
            return (_ref10 = '' + v1) === null || _ref10 === void 0 ? void 0 : _ref10.localeCompare(v2, undefined, {
              numeric: true
            });
          }
        }
      }]);
    }
    const balanceIndex = columns.findIndex(i => i.field === 'balance');
    columns.splice(balanceIndex, 1);
  }
  const BASE_ROW_HEIGHT = 73;
  const FINAL_STATEMENT_ROW_HEIGHT = BASE_ROW_HEIGHT + 22;

  // Custom CSV download logic
  const handleDownloadCsv = () => {
    var _sortModel$, _sortModel$2;
    const compare = (a, b) => a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
    exportCSVFromDataGrid({
      columns,
      name: 'residencies_table.csv',
      rows: store.residencies.searchResidenciesAggregateAsync.inProgress ? [] : sortModel && ((_sortModel$ = sortModel[0]) === null || _sortModel$ === void 0 ? void 0 : _sortModel$.field) === 'unitName' ? ((_sortModel$2 = sortModel[0]) === null || _sortModel$2 === void 0 ? void 0 : _sortModel$2.sort) === 'asc' ? [...getResidentRows].sort((a, b) => compare(a.unitName, b.unitName)) : [...getResidentRows].sort((a, b) => compare(b.unitName, a.unitName)) : getResidentRows
    });
  };
  const CustomColumnMenu = props => {
    return /*#__PURE__*/React.createElement(GridColumnMenu, _extends({}, props, {
      slots: {
        columnMenuUserItem: () => /*#__PURE__*/React.createElement("div", {
          className: classes.exportCSV
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: handleDownloadCsv,
          size: "small",
          variant: "contained"
        }, "Export CSV"))
      },
      slotProps: {
        columnMenuUserItem: {
          displayOrder: 15
        }
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.tableContainer, " ").concat(store.residenciesMultiActionStore.selectedDetails.length > 0 ? 'batch-bar' : '')
  }, /*#__PURE__*/React.createElement(DataGrid, {
    getRowId: row => {
      return "".concat(row.unitId, "-").concat(row === null || row === void 0 ? void 0 : row.propertyId, "-").concat(row === null || row === void 0 ? void 0 : row.residencyId, "-").concat(row === null || row === void 0 ? void 0 : row.accountId);
    },
    className: classes.grid,
    getCellClassName: params => {
      var _params$row3, _params$row4;
      return !params.row.accountId || typeof ((_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.isEnrolmentScheduled) === 'boolean' && !!((_params$row4 = params.row) !== null && _params$row4 !== void 0 && _params$row4.isEnrolmentScheduled) ? classes.disabledCell : '';
    },
    isRowSelectable: params => {
      var _params$row5, _params$row6;
      return !!params.row.accountId || !(typeof ((_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.isEnrolmentScheduled) === 'boolean' && (_params$row6 = params.row) !== null && _params$row6 !== void 0 && _params$row6.isEnrolmentScheduled);
    },
    onCellClick: handleCellClick,
    onRowSelectionModelChange: newSelectionModel => {
      setSelectedRows(newSelectionModel);
    },
    loading: store.residencies.searchResidenciesAggregateAsync.inProgress,
    disableRowSelectionOnClick: true,
    hideFooterSelectedRowCount: true,
    columnHeaderHeight: 80,
    columns: columns,
    columnVisibilityModel: columnVisibilityModel,
    onColumnVisibilityModelChange: newModel => setColumnVisibilityModel(newModel),
    rowHeight: BASE_ROW_HEIGHT,
    getRowHeight: rowData => {
      var _rowData$model;
      if (!!((_rowData$model = rowData.model) !== null && _rowData$model !== void 0 && (_rowData$model = _rowData$model.finalStatement) !== null && _rowData$model !== void 0 && _rowData$model.status)) {
        return FINAL_STATEMENT_ROW_HEIGHT;
      } else {
        return null;
      }
    },
    rows: store.residencies.searchResidenciesAggregateAsync.inProgress ? [] : getResidentRows
    // rowCount={store.residencies.searchResidenciesAggregateAsync.inProgress ? 0 : getResidentRows?.length}
    ,
    rowLength: store.residencies.searchResidenciesAggregateAsync.inProgress ? 0 : getResidentRows === null || getResidentRows === void 0 ? void 0 : getResidentRows.length,
    rowSelectionModel: selectedRows,
    pageSizeOptions: [25, 50, 100, {
      value: -1,
      label: 'All'
    }],
    initialState: {
      sorting: {
        sortModel: sortModel
      }
    },
    sortModel: sortModel,
    resizeThrottleMs: 300,
    onSortModelChange: model => handleSetSortModel(model),
    paginationModel: paginationModel,
    onPaginationModelChange: model => handleSetPaginationModel(model),
    slots: {
      columnMenu: CustomColumnMenu,
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: properties => /*#__PURE__*/React.createElement(Button, _extends({}, properties, {
        variant: "actionButton"
      })),
      BaseTextField: properties => /*#__PURE__*/React.createElement(TextField, _extends({}, properties, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    localeText: {
      noRowsLabel: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NoDataPlaceholder, {
        text: "No matching data found \uD83D\uDE2D\n Please adjust your filter settings!"
      }))
    }
  }), /*#__PURE__*/React.createElement(ResidentModal, {
    key: 'MultiPropertyResidenciesDataGrid_ResidentModal_key',
    isOpen: tenantModalIsOpen,
    handleOpen: openTenantModal,
    handleClose: closeModal,
    activeTab: activeTab,
    livableTab: livableTab,
    setActiveTab: setActiveTab,
    propertyId: currentPropertyIdForResidentModal,
    residencyId: currentResidentId,
    unitName: currentUnitName,
    accountId: currentAccountId,
    handleNavigation: handleNavigation,
    dataNavigation: dataNavigation,
    newBillingActivated: true,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), store.residencies.dataGrid.occupancyModal && /*#__PURE__*/React.createElement(OccupancyUpdateModal, {
    trigger: /*#__PURE__*/React.createElement("i", {
      id: "DGOccupancyUpdateModal"
    }),
    currentOccupancy: modalTempData.occupancy,
    buildingId: (_modalTempData$rowDat = modalTempData.rowData) === null || _modalTempData$rowDat === void 0 || (_modalTempData$rowDat = _modalTempData$rowDat.unitPropertyInfo) === null || _modalTempData$rowDat === void 0 ? void 0 : _modalTempData$rowDat.propertyBuildingId,
    unitData: modalTempData.unitData,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), store.residencies.dataGrid.enrollmentModal ? /*#__PURE__*/React.createElement(EnrollmentModal, {
    key: 'MultiPropertyResidenciesDataGrid_EnrollmentModal_key',
    testId: "DGEnrollmentModal",
    trigger: /*#__PURE__*/React.createElement("i", {
      id: "DGEnrollmentModal"
    }),
    unitIsDefined: modalTempData.unitname,
    propertyId: (_modalTempData$rowDat2 = modalTempData.rowData) === null || _modalTempData$rowDat2 === void 0 || (_modalTempData$rowDat2 = _modalTempData$rowDat2.unitPropertyInfo) === null || _modalTempData$rowDat2 === void 0 ? void 0 : _modalTempData$rowDat2.id,
    page: page,
    portfolioId: (_store$homeDashboardS16 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS16 === void 0 || (_store$homeDashboardS16 = _store$homeDashboardS16.propertyPortfolioDetails((_modalTempData$rowDat3 = modalTempData.rowData) === null || _modalTempData$rowDat3 === void 0 || (_modalTempData$rowDat3 = _modalTempData$rowDat3.unitPropertyInfo) === null || _modalTempData$rowDat3 === void 0 ? void 0 : _modalTempData$rowDat3.id)) === null || _store$homeDashboardS16 === void 0 ? void 0 : _store$homeDashboardS16.id,
    enablePortfolioSelect: false,
    enablePropertySelect: true,
    newBillingActivated: true,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }) : null, isFinalStatementEstimationEnabled && selectedUnit.residencyId && /*#__PURE__*/React.createElement(FSEBillModal, {
    disabled: store.fse.submitFinalStatementsAsync.inProgress,
    disabledTrigger: true,
    isOpen: store.fse.FSEBillGeneralModalIsOpen,
    residentName: selectedUnit.residentName,
    residencyId: selectedUnit.residencyId,
    propertyId: selectedUnit.propertyId,
    setFSEBillModalIsOpen: store.fse.setFSEBillGeneralModalIsOpen,
    submitFSE: handleSubmitFinalStatements,
    triggerType: "disabledTrigger",
    unitName: selectedUnit.unitName,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }));
});